const nav = {
    hamburger: () => {
        const hamburger  = document.querySelector('#mobile-nav'),
               nav       = document.querySelector('#nav-main'),
               headerNav = document.querySelector('.header-nav');
        if (!hamburger) {
            return;
        }
        hamburger.addEventListener('click', () => {
            hamburger.classList.toggle('open');
            nav.classList.toggle('open');

        })
        window.addEventListener('scroll', () => {
            if(window.scrollY > 0) {
                headerNav.classList.add('active')
            } else {
                headerNav.classList.remove('active')
            }

        })
    },
    searchBox: () => {
        const searchBox = document.querySelector('.search-box'),
            form        = document.querySelector('.search-box__form'),
            formClear   = document.querySelector('.search-box__form__clear'),
            input       = document.querySelector('.search-box__search-input');

        input.addEventListener('focus',function () {
            nav.isActive(searchBox)
        })
        input.addEventListener('blur',function () {
            nav.isActive(searchBox)
        })
        input.addEventListener('input',function () {
            formClear.classList.add('active');
        })
        formClear.addEventListener('click',function () {
            formClear.classList.remove('active');
            input.value = '';
        })
    },
    langSwitcher: () => {
        const switcher      = document.querySelector('.lang-menu__icons'),
              langMenu      = document.querySelector('.lang-menu'),
              langMenuLangs = document.querySelectorAll('.lang-menu__langs li');

        // langMenuLangs.forEach(function (el) {
        //     el.addEventListener('click', function (e) {
        //         e.preventDefault()
        //         nav.isActive(el)
        //     })
        // });
        switcher.addEventListener('click', function () {
            nav.isActive(langMenu)
        })
        document.addEventListener('click', function (event) {
            if (!langMenu.contains(event.target)) {
                langMenu.classList.remove('active')
            }
        });
    },
    isActive: (element) => {
        if (element.classList.contains('active')) {
            element.classList.remove('active')
        } else {
            element.classList.add('active')
        }
    },
    submenu: () => {
        const dropdownIcons = document.querySelectorAll('.header-nav__menu > .link-menu > a > svg');
        if(dropdownIcons.length === 0){
            return;
        }
        dropdownIcons.forEach((icon, index) => {
            icon.addEventListener('click', (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                const parent = ev.target.closest('.link-menu');
                if(!parent){
                    return;
                }
                parent.classList.toggle('active');
            })
        });
    }
}

export default nav;
